import { createContext, useContext } from 'react';
import { AuthProvider } from '~/enums';

export interface SignInWithRedirectOptions {
  connection?: string;
  language?: string;
  market?: string;
  returnTo?: string;
  redirectUri?: string;
  skipPrompt?: boolean;
  clientId?: number;
}

export interface IAuthContext {
  provider: AuthProvider;
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: () => Promise<void>;
  signInWithRedirect: (options: SignInWithRedirectOptions) => Promise<void>;
}

export enum CognitoAuthEvent {
  SignedIn = 'signedIn',
  SignedOut = 'signedOut',
  TokenRefresh = 'tokenRefresh',
  TokenRefreshFailure = 'tokenRefresh_failure',
  SignInWithRedirect = 'signInWithRedirect',
  SignInWithRedirectFailure = 'signInWithRedirect_failure',
  CustomOAuthState = 'customOAuthState',
}

export const AuthContext = createContext<IAuthContext | undefined>(undefined);

export const useAuth = (): IAuthContext => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
